import React from 'react';
import { PiPlusCircle } from "react-icons/pi";

interface AddTemplateCardProps {
  onClick: () => void;
}

const AddTemplateCard: React.FC<AddTemplateCardProps> = ({ onClick }) => {
  return (
    <div 
      className="border-2 border-dashed border-[#E9E9E7] rounded-2xl p-5 flex flex-col cursor-pointer
        transition-all hover:border-[#D1D1CF] hover:bg-[#FBFBFA]"
      onClick={onClick}
    >
      {/* 图片占位区域 - 与其他卡片保持一致的高度 */}
      <div className="w-full aspect-[4/3] bg-[#F7F7F5] rounded-xl overflow-hidden mb-4 flex items-center justify-center">
        <PiPlusCircle className="text-4xl text-[#91918E] opacity-60" />
      </div>
      <div>
        <div className="flex items-center gap-1.5 mb-1">
          <h3 className="text-sm font-bold">添加自定义模板</h3>
        </div>
        <p className="text-[11px] text-[#91918E] leading-relaxed">创建专属模板</p>
      </div>
    </div>
  );
};

export default AddTemplateCard;
